import config from "@/config/config";
import { BmfwfLink, BmfwfLinkResolved } from "@/models/BmfwfLinkverwaltung";
import { BmbLink, BmbLinkResolved } from "@/models/BmbLinkverwaltung";
import { BhagLink, BhagLinkResolved } from "@/models/BhagLinkverwaltung";

class LinkverwaltungService {

  getMyLinksBmfwf(endpointUrl: string): Promise<BmfwfLinkResolved[]> {
    return fetch(endpointUrl, {
      headers:{
        'Content-Type':'application/json'
      },
    })
      .then(response => response.json())
      .catch(error => {
        console.error('Unable to load personalized LinkList', error)
        return [];
      })
  }

  saveMyLinksBmfwf(bmfwflinks: BmfwfLink[]): Promise<any> {
    return fetch(config.baseApiUrl+'bmfwf/v1/favorites', {
      method: 'POST',
      headers:{
        'Content-Type':'application/json'
      },
      body: JSON.stringify(bmfwflinks.map( link =>{
        if(link.internal){
          return{
            favorite: link.favorite,
            internalUuid: link.internalUuid,
          }
        }else{
          return{
            favorite: link.favorite,
            name: link.name,
            externalUrl: link.externalUrl,
          }
        }

      }))
    })
    .then(response => response.text())
    .catch(error => {
      console.error('Unable to save personalized LinkList', error)
    })

  }

  addLinkBmfwf(uuid: string, seitenname:string) {

   return fetch(config.baseApiUrl+'bmfwf/v1/favorites/', {
      method: 'PUT',
      headers:{
        'Content-Type':'application/json'
      },
      body: JSON.stringify({
        'favorite': true,
        'internalUuid':uuid,
        'name':seitenname ,
        'externalUrl': '',
      })
      })
    .then(response => response.text())
    .catch(error => console.error('Unable to add Link to personalized LinkList', error));
  }

  removeLinkBmfwf(deleteId :string) {

    return fetch( config.baseApiUrl+'bmfwf/v1/favorites/'+encodeURIComponent(deleteId), {
      method: 'DELETE',
      headers:{
        'Content-Type':'application/json'
      }

    })
    .then(response => response.text())
    .catch(error => console.error('Unable to delete Link from personalized LinkList', error));
  }


  getMyLinksBmb(endpointUrl: string): Promise<BmbLinkResolved[]> {
    return fetch(endpointUrl, {
      headers:{
        'Content-Type':'application/json'
      },
    })
      .then(response => response.json())
      .catch(error => {
        console.error('Unable to load personalized LinkList', error)
        return [];
      })
  }

  saveMyLinksBmb(bmblinks: BmbLink[]): Promise<any> {
    return fetch(config.baseApiUrl+'bmb/v1/favorites', {
      method: 'POST',
      headers:{
        'Content-Type':'application/json'
      },
      body: JSON.stringify(bmblinks.map( link =>{
        if(link.internal){
          return{
            favorite: link.favorite,
            internalUuid: link.internalUuid,
          }
        }else{
          return{
            favorite: link.favorite,
            name: link.name,
            externalUrl: link.externalUrl,
          }
        }

      }))
    })
    .then(response => response.text())
    .catch(error => {
      console.error('Unable to save personalized LinkList', error)
    })

  }

  addLinkBmb(uuid: string, seitenname:string) {

   return fetch(config.baseApiUrl+'bmb/v1/favorites/', {
      method: 'PUT',
      headers:{
        'Content-Type':'application/json'
      },
      body: JSON.stringify({
        'favorite': true,
        'internalUuid':uuid,
        'name':seitenname ,
        'externalUrl': '',
      })
      })
    .then(response => response.text())
    .catch(error => console.error('Unable to add Link to personalized LinkList', error));
  }

  removeLinkBmb(deleteId :string) {

    return fetch( config.baseApiUrl+'bmb/v1/favorites/'+encodeURIComponent(deleteId), {
      method: 'DELETE',
      headers:{
        'Content-Type':'application/json'
      }

    })
    .then(response => response.text())
    .catch(error => console.error('Unable to delete Link from personalized LinkList', error));
  }


  getMyLinksBhag(endpointUrl: string): Promise<BhagLinkResolved[]> {
    return fetch(endpointUrl, {
      headers:{
        'Content-Type':'application/json'
      },
    })
      .then(response => response.json())
      .catch(error => {
        console.error('Unable to load personalized LinkList', error)
        return [];
      })
  }

  saveMyLinksBhag(bhaglinks: BhagLink[]): Promise<any> {
    return fetch(config.baseApiUrl+'bhag/v1/favorites', {
      method: 'POST',
      headers:{
        'Content-Type':'application/json'
      },
      body: JSON.stringify(bhaglinks.map( link =>{
        if(link.internal){
          return{
            favorite: link.favorite,
            internalUuid: link.internalUuid,
          }
        }else{
          return{
            favorite: link.favorite,
            name: link.name,
            externalUrl: link.externalUrl,
          }
        }

      }))
    })
    .then(response => response.text())
    .catch(error => {
      console.error('Unable to save personalized LinkList', error)
    })

  }

  addLinkBhag(uuid: string, seitenname:string) {

   return fetch(config.baseApiUrl+'bhag/v1/favorites/', {
      method: 'PUT',
      headers:{
        'Content-Type':'application/json'
      },
      body: JSON.stringify({
        'favorite': true,
        'internalUuid':uuid,
        'name':seitenname ,
        'externalUrl': '',
      })
      })
    .then(response => response.text())
    .catch(error => console.error('Unable to add Link to personalized LinkList', error));
  }

  removeLinkBhag(deleteId :string) {

    return fetch( config.baseApiUrl+'bhag/v1/favorites/'+encodeURIComponent(deleteId), {
      method: 'DELETE',
      headers:{
        'Content-Type':'application/json'
      }

    })
    .then(response => response.text())
    .catch(error => console.error('Unable to delete Link from personalized LinkList', error));
  }


}


export default new LinkverwaltungService()
